module.exports = "#myModal{\n    background-image: url('bg-01.jpg'); \n    background-size:220%\n}"